import classNames from 'classnames'
import Image from 'next/image'
import React from 'react'
import styles from './ItemTile.module.scss'
import type { ItemTileProps } from './types'
import { CounterVariant, ProductCounter } from '@/tools/ui'
import { ItemTileSkeleton } from '@/tools/ui/components'

export const ItemTile: React.FC<ItemTileProps> = ({
  imgAlt,
  imgSrc,
  price,
  originalPrice,
  isLoading = false,
  name,
  value = 0,
  tags,
  showCounter = true,
  canAddToCart = true,
  onAdd: handleOnAdd = () => {},
  onRemove: handleOnRemove = () => {},
  onClick: handleOnClick = () => {},
}) =>
  isLoading ? (
    <ItemTileSkeleton />
  ) : (
    <div className={styles.itemTile} onClick={handleOnClick}>
      <div className={styles.imageContainer}>
        <Image
          fill
          alt={imgAlt}
          className={styles.image}
          src={imgSrc}
          style={{ objectFit: 'cover' }}
        />
        {showCounter && (
          <div className={styles.itemAction}>
            <ProductCounter
              disabled={!canAddToCart}
              value={value}
              variant={CounterVariant.floating}
              onAdd={handleOnAdd}
              onRemove={handleOnRemove}
            />
          </div>
        )}
        {tags && <div className={styles.tagsContainer}>{tags}</div>}
      </div>
      <div className={styles.description}>
        <h3 className={classNames('pintxo-typography-body2', styles.title)}>{name}</h3>
        <div className={styles.priceContainer}>
          <span className="pintxo-typography-body2">{price}</span>
          {originalPrice && (
            <span className={classNames(styles.originalPrice, 'pintxo-typography-caption')}>
              {originalPrice}
            </span>
          )}
        </div>
      </div>
    </div>
  )
